import React from 'react';
import { useTranslation } from 'react-i18next';
import CountrySelect from 'components/CountrySelect';
import { SectionWrapper } from 'pages/SettingsPage/General/GeneralSettings.styled';
import { Flex, Text } from 'UI';
import { Country } from 'utils/i18n/Country';

interface Props {
  selected: string;
  onSelect: (selected: string) => void;
  enabled: boolean;
}

const SelectCountry = ({ selected, onSelect, enabled }: Props) => {
  const { t } = useTranslation();
  const availableCountries = Country.listCountries();
  const initialCountry = Country.findByKeyMandatory(selected);

  const handleSelectCountry = (selectedCountry: Country) => {
    onSelect(selectedCountry.key);
  };

  return (
    <SectionWrapper data-cy={'country-selection'} $marginY={15}>
      <Flex direction={'column'} gap={15}>
        <Text type="heading4">{t('common.select_country', 'Select country')}</Text>
        <Text type="base">
          {t(
            'backoffice.central-settings.select.country.description',
            'Select a country from the RPartStore network to configure its tire module settings. Each country can have independent' +
              ' tire module configuration..',
          )}
        </Text>
        <CountrySelect
          countryList={availableCountries}
          selected={initialCountry}
          onSelect={handleSelectCountry}
          disabled={!enabled}
        />
      </Flex>
    </SectionWrapper>
  );
};

export default SelectCountry;
